import React, { Component } from 'react'
import RawHtml from 'stories/components/RawHtml'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1, 0),
    borderTop: '1px dashed lightgray',
  },
}))

const SuccessPage = ({
  touched,
  error,
  SideElement,
  description,
  label,
  fullWidth,
  stateProps,
  ...props
}) => {
  const classes = useStyles()

  const classNames = {
    [classes.root]: true,
    'formz-successPage-input': true,
    'formz-has-focus': stateProps.hasFocus,
    'formz-has-error': error,
    'full-width': fullWidth,
  }

  return (
    <FieldRowWrapper
      className={classNames}
      error={error}
      touched={touched ? touched.toString() : undefined}
    >
      <label className="formz-field-and-label-holder">
        <div className="formz-section-input">
          {label && <h3>{label}</h3>}
          <RawHtml content={description} />
        </div>

        {SideElement && <SideElement />}
      </label>
    </FieldRowWrapper>
  )
}

class SuccessPageClass extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasFocus: false,
    }
  }

  onInputFocus = () => {
    this.setState({ hasFocus: true }, () => {
      this.props.onFocus && this.props.onFocus()
    })
  }

  onInputBlur = () => {
    this.setState({ hasFocus: false }, () => {
      this.props.onBlur && this.props.onBlur()
    })
  }

  getInputValue = () => this.props.value

  render() {
    return <SuccessPage {...this.props} stateProps={this.state} />
  }
}

export default SuccessPageClass
